import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { color, typography } from 'styled-system';
import { Box } from '../grid/Grid';
var StyledText = styled(Box)(_templateObject(), color, typography, function (props) {
  return props.isTruncated && ellipsis();
});
export var Text =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var _ref$m = _ref.m,
      m = _ref$m === void 0 ? 0 : _ref$m,
      props = _objectWithoutProperties(_ref, ["m"]);

  return (
    /*#__PURE__*/
    React.createElement(StyledText, _extends({
      ref: ref,
      as: "p",
      m: m
    }, props))
  );
});
Text.defaultProps = {
  fontSize: '14px',
  fontWeight: 'normal',
  lineHeight: 1.5
};